class Documento {
  constructor(baseUri,sector,internal,archivo,autor,contentType,extension,fechaCreado,path,identifier,fileSize,tipo,tipoCodigo,esThuban,origen){
    this.baseUri=baseUri
    this.sector=sector
    this.internal=internal
    this.nombre=archivo
    this.autor=autor
    this.contentType=contentType
    this.extension=extension
    this.fechaCreado=fechaCreado
    this.path=path
    this.identifier=identifier
    this.fileSize=fileSize
    this.tipoDescripcion=tipo
    this.tipo=tipoCodigo
    this.esThuban=esThuban
    this.origen=origen
  } 
}
export default Documento



